import PropTypes from 'prop-types';
import { ImageListItem } from '@mui/material';
import { themeColors } from '../theme/theme';
import NextImage from 'next/image';

export function Image({ name, src, alt = '', width, height, style, ...rest }) {
  const resolvedSrc = name ? `/assets/images/${name}.svg` : src;

  return (
    <ImageListItem style={{ background: themeColors.backgroundColor, ...style }}>
      <NextImage
        src={resolvedSrc}
        alt={alt}
        width={width}
        height={height}
        style={{ display: 'block', maxWidth: '100%', ...style }}
        {...rest}
      />
    </ImageListItem>
  );
}

Image.propTypes = {
  name: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};
